import { remStyleSheet } from '@max/leez-style-util';
export const styles = remStyleSheet({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 12,
        overflow: 'hidden'
    },
    finishRoomContainer: {
        justifyContent: 'center',
        alignItems: 'center'
    },
    finishDescContainer: {
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center'
    },
    finishTextContainer: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    finishText: {
        fontWeight: '500',
        color: '#FFFFFF',
        fontSize: 18,
        fontFamily: 'PingFangSC-Regular',
        paddingLeft: 6,
        paddingRight: 6
    },
    finishTextDashLine: {
        width: 40,
        height: 1
    },
    durationTimeText: {
        fontWeight: '400',
        color: '#FFFFFF',
        fontSize: 10,
        fontFamily: 'PingFangSC-Regular',
        marginTop: 2
    },
    liveRoomContainer: {
        alignItems: 'center',
        borderRadius: 12,
        overflow: 'hidden'
    },
    livingRoomDescContainer: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        alignItems: 'center'
    },
    livingRoomHeaderContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        position: 'absolute',
        backgroundColor: '#00000099',
        borderRadius: 9,
        height: 18,
        paddingLeft: 2,
        paddingRight: 6,
        top: 15,
        left: 14
    },
    livingRoomHeaderText: {
        fontWeight: '400',
        color: '#FFFFFF',
        fontSize: 12,
        fontFamily: 'PingFangSC-Regular',
        marginLeft: 2
    },
    jumpToLiveRoomContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        bottom: 20
    },
    jumpToLiveRoomText: {
        fontWeight: '500',
        color: '#FFFFFF',
        fontSize: 12,
        fontFamily: 'PingFangSC-Regular'
    }
});
